import { jwtDecode } from 'jwt-decode';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { EnterpriseService } from './enterprise.service';
import { ThemeService } from './theme.service';
import { ClientProviderService } from './client-provider.service';
import { GlobalVarsService } from './global-variables.service';
import { SidebarService } from './sidebar.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private enterpriseService = inject(EnterpriseService);
  private themeService = inject(ThemeService);
  private clientProviderService = inject(ClientProviderService);
  private globalStorage = inject(GlobalVarsService);
  private sidebarService = inject(SidebarService);

  login(username: string, password: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { username: username.trim(), password };

    return this.http.post(`${environment.api}/login`, body, { headers, responseType: 'text' }).pipe(
      map((response: any) => {
        const token = response;
        const user: any = jwtDecode(token);

        this.enterpriseService.setSchemesList([]);
        this.enterpriseService.setCustomerId('');
        this.enterpriseService.setEconomicGroup('');
        this.enterpriseService.setDocument('');
        this.enterpriseService.setEnterpriseList([]);
        this.enterpriseService.setEnterprise(undefined);
        this.clientProviderService.updateCustomerId(null);
        this.clientProviderService.updateDocument(null);
        this.globalStorage.clear();
        this.sidebarService.reset();

        sessionStorage.setItem('token', token);
        sessionStorage.setItem('enterpriseSelectedCustomerId', user.customerId as string);
        sessionStorage.setItem('user', JSON.stringify(user));
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  logout() {
    const systemType = sessionStorage.getItem('systemType') as string;
    this.enterpriseService.setSchemesList([]);
    this.enterpriseService.setCustomerId('');
    this.enterpriseService.setEconomicGroup('');
    this.enterpriseService.setDocument('');
    this.enterpriseService.setEnterpriseList([]);
    this.enterpriseService.setEnterprise(undefined);
    this.clientProviderService.updateCustomerId(null);
    this.clientProviderService.updateDocument(null);
    this.globalStorage.clear();
    this.sidebarService.reset();
    sessionStorage.clear();
    localStorage.clear();

    let redirectUrl = '/';
    const reference = this.themeService.getReference();

    if (reference()) {
      redirectUrl = reference() as string;
    }

    switch (systemType) {
      case 'QIMA':
        redirectUrl = '/qima/login';
        break;
      case 'MINERVA':
        redirectUrl = '/minerva/login';
        break;
      case 'CARGILL':
        redirectUrl = '/cargill/login';
        break;
      case 'ACELEN':
        redirectUrl = '/acelen/login';
        break;
      case 'IRANCHO':
        redirectUrl = '/irancho/login';
        break;
      case 'WALMART':
        redirectUrl = '/walmart/login';
        break;
      case 'SAFETRACE':
        redirectUrl = '/safetrace/login';
        break;
      case 'THOMAS_FOODS':
        redirectUrl = '/thomas-foods/login';
        break;
      case 'INTERSTATE_MEAT_DISTRIBUTORS':
        redirectUrl = '/interstate-meat/login';
        break;
      case 'ASSAI':
        redirectUrl = '/assai/login';
        break;
      case 'GRAOSDOPARA':
        redirectUrl = '/graosdopara/login';
        break;
      default:
        break;
    }

    // this.router.navigateByUrl(redirectUrl , { skipLocationChange: true }).then(() => {
    //   this.router.navigateByUrl(redirectUrl).then(() => {
    //     window.location.reload();
    //   });
    // });
    if (!redirectUrl.includes('/login')) {
      this.router.navigate(['/login', redirectUrl]);
    } else {
      this.router.navigate([redirectUrl]);
    }
  }

  changePassword(body: { username: string, oldPassword: string, newPassword: string }) {
    return this.http.post(`${environment.api}/user/change-password`, body, {})
      .pipe(res => res, error => error);
  }

  sendEmailResetPassword(email: string, frontUrl?: string) {
    const params = new HttpParams()
      .set('email', email)
      .set('frontUrl', frontUrl ? frontUrl : 'https://qima.agrotransparencia.com.br');

    const http = {
      headers: new HttpHeaders(),
      params,
      responseType: 'text' as 'json',
    };

    return this.http.post(`${environment.api}/user/forgot-password`, {}, http)
      .pipe(res => res, error => error)
  }

  doubleAuthentication(username: string, code: string) {
    const http = {
      headers: new HttpHeaders(),
      responseType: 'text' as 'json',
    };
    return this.http.post(`${environment.api}/auth/verify-2fa?username=${username}&code=${code}`, {}, http).pipe(
      map((response: any) => {
        const token = response;
        sessionStorage.setItem('token', token);
        const user = jwtDecode(token);
        sessionStorage.setItem('user', JSON.stringify(user));
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    )
  }
}
